import useSWR from 'swr';

import { getProposalData } from '../firebase/pricing/proposals';
import { Grade } from '../types/pricing';

export const usePricing = (region: string, grade: Grade) => {
  const { data, error } = useSWR(`pricing-${region}-${grade}`, () => getProposalData(region, grade));

  return {
    pricing: data,
    isLoading: !error && !data,
    error,
  };
};